angular.module('app').config(passwordRecoveryEditRouting);

function passwordRecoveryEditRouting($routeProvider) {
  $routeProvider.when('/password_recovery/edit/:tk/:email', {
    pageTitle: 'RESET_YOUR_PASSWORD',
    template: '<password-recovery-edit-page></password-recovery-edit-page>',
  });
}

passwordRecoveryEditRouting.$inject = ['$routeProvider'];

// /password_recovery/edit/:tk/:email

// /password_recovery/edit?tk=:tkUser&email=:emailUser
// ?tk=:tokenUser&email=:emailUser

// http://localhost:4200/#/password_recovery/edit?tk=1234&email=pablo.arroyo@dotcreek.com
// 'anon.password_recovery/:token/edit?email=:emailUser'
